<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Gate de Entrada</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Nova Entrada"
          icon="assets/add.svg"
          (click)="navegarNovaEntrada()"
        ></app-botao>
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"
        ></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Listagem de Entradas no Gate</div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getEntradas()">
            <div class="table-filters">
              <app-input
                label="Cód. Gate Entrada"
                placeholder="Digite aqui"
                name="PK_GATE_ENTR"
                formControlName="PK_GATE_ENTR"
                width="100%"
              ></app-input>
              <app-input
                label="ID Empresa"
                placeholder="Digite aqui"
                name="PK_EPSA"
                formControlName="PK_EPSA"
                width="100%"
              ></app-input>
              <app-input
                label="Motorista"
                placeholder="Digite aqui"
                name="NM_MTRT"
                formControlName="NM_MTRT"
                width="100%"
              ></app-input>
              <app-input
                label="Placa Cavalo"
                placeholder="Digite aqui"
                name="TX_PLCA_CAVA"
                mask="AAA-0A00"
                formControlName="TX_PLCA_CAVA"
                width="100%"
              ></app-input>
              <span></span>
              <app-input
                type="select"
                label="Situação"
                name="NU_SAID_STTS"
                formControlName="NU_SAID_STTS"
                [selectData]="statusOptions"
                (blurEvent)="getEntradas()"
                (ngModelChange)="onStatusChange($event)"
              ></app-input>
              <app-input
                type="datetime-local"
                label="Data Início"
                placeholder="Digite aqui"
                name="DT_GATE_ENTR_INIC"
                formControlName="DT_GATE_ENTR_INIC"
                width="100%"
              ></app-input>
              <app-input
                type="datetime-local"
                label="Data Fim"
                placeholder="Digite aqui"
                name="DT_GATE_ENTR_FIM"
                formControlName="DT_GATE_ENTR_FIM"
                width="100%"
              ></app-input>
            </div>
          </form>
        </div>
      </div>
      <div class="carretas-patio-wrapper">
        <div class="carretas-patio-badge">
          <svg class="carretas-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 55" fill="currentColor">
            <rect x="2" y="5" width="62" height="34" rx="2" />
            <path d="M64,5 L64,39 L88,39 L88,22 Q88,18 85,15 L76,5 Z" />
            <rect x="72" y="9" width="13" height="14" rx="1" fill="white" />
            <rect x="2" y="39" width="86" height="4" />
            <circle cx="18" cy="47" r="7" fill="currentColor" stroke="white" stroke-width="2" />
            <circle cx="34" cy="47" r="7" fill="currentColor" stroke="white" stroke-width="2" />
            <circle cx="78" cy="47" r="7" fill="currentColor" stroke="white" stroke-width="2" />
          </svg>
          <span>{{ quantidadeCarretasPatio }} caminhões no pátio</span>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela *ngIf="!isLoading" [data]="tableData" [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" (ngModelChange)="getEntradas()" class="table-filters">
      <app-input
        label="N° de Agendamento"
        placeholder="Digite aqui"
        name="PK_GATE_ENTR"
        formControlName="PK_GATE_ENTR"
        width="100%"
      ></app-input>
      <app-input
        label="ID Empresa"
        placeholder="Digite aqui"
        name="PK_EPSA"
        formControlName="PK_EPSA"
        width="100%"
      ></app-input>
      <app-input
        label="Motorista"
        placeholder="Digite aqui"
        name="NM_MTRT"
        formControlName="NM_MTRT"
        width="100%"
      ></app-input>
      <app-input
        label="Placa Cavalo"
        placeholder="Digite aqui"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        width="100%"
      ></app-input>
      <app-input
        type="select"
        label="Situação"
        name="NU_SAID_STTS"
        formControlName="NU_SAID_STTS"
        [selectData]="statusOptions"
        (blurEvent)="getEntradas()"
        (ngModelChange)="onStatusChange($event)"
      ></app-input>
      <app-input
        type="datetime-local"
        label="Data Início"
        placeholder="Digite aqui"
        name="DT_GATE_ENTR_INIC"
        formControlName="DT_GATE_ENTR_INIC"
        width="100%"
      ></app-input>
      <app-input
        type="datetime-local"
        label="Data Fim"
        placeholder="Digite aqui"
        name="DT_GATE_ENTR_FIM"
        formControlName="DT_GATE_ENTR_FIM"
        width="100%"
      ></app-input>
    </form>
    <app-card *ngIf="!isLoading" [data]="tableData" [rows]="tableColumns" [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length">Nenhum registro encontrado.</app-subtitulo>
  <div class="paginacao">
    <app-paginacao *ngIf="tableData.length" [pages]="maxPages" (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
